<div class="timeline-details">
	<div class="title">
		{{title}}
	</div>
	<div class="description">
		{{description}}
	</div>
</div>
